import React, {type ReactNode} from "react";
import {HoverCard, HoverCardContent, HoverCardTrigger} from "@/components/ui/hover-card.tsx";
import {cn} from "@/lib/utils";


interface HoverTipProps{
    children?: ReactNode;
    content: ReactNode;
    delay?: number;
    position?: 'top' | 'bottom' | 'left' | 'right';

}
export const HoverTip: React.FC<HoverTipProps> = ({children,content, delay = 300,
                                                      position = 'right',}) =>{
    return <HoverCard openDelay={delay}>
        <HoverCardTrigger asChild>
            <div>
                {children || ''}
            </div>
        </HoverCardTrigger>
        <HoverCardContent 
            className={cn(
                "hover-tip-content p-[6px_8px] rounded-md text-xs min-w-[10px] max-w-[320px] w-auto z-[1000]",
                "bg-popover text-popover-foreground border border-border shadow-md flex flex-col justify-end"
            )} 
            side={position}
        >
            <div className="self-end">{content || ''}</div>
        </HoverCardContent>
    </HoverCard>
}
